import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy, Medal, Award, Star } from 'lucide-react';

const API = `${window.location.origin}/api`;

const RANK = {
  1: { Icon: Trophy, color: 'text-amber-500' },
  2: { Icon: Medal, color: 'text-slate-400' },
  3: { Icon: Award, color: 'text-orange-600' },
};

export default function SidebarBadges() {
  const [badges, setBadges] = useState([]);

  useEffect(() => {
    axios.get(`${API}/badges/my`)
      .then((res) => setBadges(res.data.badges || []))
      .catch(() => setBadges([]));
  }, []);

  if (!badges.length) return null;

  // Derece bazında grupla (kategori bağımsız), adet say
  const groups = {};
  badges.forEach((b) => {
    const isMention = b.type === 'mention';
    const key = isMention ? 'mention' : `rank-${b.rank}`;
    if (!groups[key]) {
      groups[key] = {
        key, isMention, rank: b.rank,
        label: isMention ? 'Mansiyon' : `${b.rank}.`,
        count: 0,
      };
    }
    groups[key].count += 1;
  });
  const items = Object.values(groups).sort((a, b) => {
    if (a.isMention !== b.isMention) return a.isMention ? 1 : -1;
    return (a.rank || 0) - (b.rank || 0);
  });

  return (
    <div data-testid="sidebar-badges" className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-3">
      {items.map((g) => {
        const r = RANK[g.rank] || RANK[1];
        const Icon = g.isMention ? Star : r.Icon;
        const color = g.isMention ? 'text-fuchsia-500' : r.color;
        return (
          <div key={g.key} data-testid="sidebar-badge-item" className="flex items-center gap-1.5" title={`${g.label} · ${g.count} adet`}>
            <Icon className={`w-5 h-5 flex-shrink-0 ${color}`} />
            <span className="text-sm font-bold text-gray-700">{g.count}</span>
          </div>
        );
      })}
    </div>
  );
}
